import Starter from '../views/starter/starter.jsx';
// ui components
import Alerts from '../views/ui-container/alert.jsx';
import Users from '../views/ui-container/users.jsx';
import Prospects from '../views/ui-container/prospects.jsx';
import Followup from '../views/ui-container/followup.jsx';
import Trial from '../views/ui-container/trial.jsx';
import Leads from '../views/ui-container/leads.jsx';
import Labels from '../views/ui-container/labels.jsx';
import TrackingMail from '../views/ui-container/tracking.jsx';
import EmailTemplate from '../views/ui-container/template.jsx';
import Wysiwyg from '../views/ui-container/wysiwyg.jsx';
import Badges from '../views/ui-container/badge.jsx';
import Buttons from '../views/ui-container/button.jsx';
import Cards from '../views/ui-container/cards.jsx';
import LayoutComponent from '../views/ui-container/layout.jsx';
import PaginationComponent from '../views/ui-container/pagination.jsx';
import PopoverComponent from '../views/ui-container/popover.jsx';
import TooltipComponent from '../views/ui-container/tooltip.jsx';
import ProspectAdd from '../views/ui-container/prospect-add.jsx';
import AddUser from '../views/ui-container/user-add.jsx';
import AddTemplate from '../views/ui-container/template-add.jsx';
import AddLabel from '../views/ui-container/label-add.jsx';
import Profile from '../views/ui-container/user-profile.jsx';
import ImageUpload from '../views/ui-container/image-upload.jsx';
import Customers from '../views/ui-container/customers.jsx';
import UploadCsv from '../views/ui-container/upload-csv.jsx';

// Icons

var ThemeRoutes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: 'mdi mdi-monitor',
    component: Starter
  },
  // {
  //   path: '/prospects',
  //   name: 'Customers',
  //   icon: 'mdi mdi-access-point',
  //   component: Prospects
  // },
  {
    path: '/prospects',
    name: 'Prospects',
    icon: 'mdi mdi-account-multiple',
    component: Prospects
  },
  // {
  //   path: '/labels',
  //   name: 'Labels',
  //   icon: 'mdi mdi-tag-multiple',
  //   component: Labels
  // },
  // {
  //   path: '/tracking-mail',
  //   name: 'Tracking',
  //   icon: 'mdi mdi-contact-mail',
  //   component: TrackingMail
  // },
  {
    path: '/followup',
    name: 'Follow Up',
    icon: 'mdi mdi-account-alert',
    component: Followup
  },
  {
    path: '/leads',
    name: 'Leads',
    icon: 'mdi  mdi-account-check',
    component: Leads
  },
  {
    path: '/trial',
    name: 'Trial',
    icon: 'mdi  mdi-access-point',
    component: Trial
  },
  {
    path: '/customers',
    name: 'Customers',
    icon: 'mdi mdi-account-box-outline',
    component: Customers,
    // iconComponent : mdiAlphaCBoxOutline
  },
  {
    path: '/templates',
    name: 'Email Templates',
    icon: 'mdi mdi-email-open',
    component: EmailTemplate
  },
  {
    path: '/users',
    name: 'Users',
    icon: 'mdi mdi-clipboard-account',
    component: Users
  },
  // {
  //   path: '/upload-image',
  //   name: 'Upload image',
  //   icon: 'mdi mdi-image-multiple',
  //   component: ImageUpload
  // },
  // { 
  //   path: '/wysiwyg', 
  //   name: 'WYSIWYG', 
  //   icon: 'mdi mdi-email-open', 
  //   component: Wysiwyg
  // },
  { path: '/my-profile', component: Profile },
  { path: '/prospect/add', component: ProspectAdd },
  { path: '/prospect/edit/:id', component: ProspectAdd },
  { path: '/user/add', component: AddUser },
  { path: '/user/edit/:id', component: AddUser },
  { path: '/template/add', component: AddTemplate },
  { path: '/template/edit/:id', component: AddTemplate },
  { path: '/label/add', component: AddLabel },
  { path: '/upload', component: UploadCsv },
  // {
  //   path: '/alert',
  //   name: 'Alerts',
  //   icon: 'mdi mdi-comment-processing-outline',
  //   component: Alerts
  // },
  // {
  //   path: '/badge',
  //   name: 'Badges',
  //   icon: 'mdi mdi-arrange-send-backward',
  //   component: Badges
  // },
  // {
  //   path: '/button',
  //   name: 'Buttons',
  //   icon: 'mdi mdi-toggle-switch',
  //   component: Buttons
  // },
  // {
  //   path: '/card',
  //   name: 'Cards',
  //   icon: 'mdi mdi-credit-card-multiple',
  //   component: Cards
  // },
  // {
  //   path: '/grid',
  //   name: 'Grid',
  //   icon: 'mdi mdi-apps',
  //   component: LayoutComponent
  // },
  // {
  //   path: '/pagination',
  //   name: 'Pagination',
  //   icon: 'mdi mdi-priority-high',
  //   component: PaginationComponent
  // },
  // {
  //   path: '/popover',
  //   name: 'Popover',
  //   icon: 'mdi mdi-pencil-circle',
  //   component: PopoverComponent
  // },
  // {
  //   path: '/ui-components/tooltip',
  //   name: 'Toltips',
  //   icon: 'mdi mdi-image-filter-vintage',
  //   component: TooltipComponent
  // },
  { path: '/', pathTo: '/dashboard', name: 'Dashboard', redirect: true }
];
export default ThemeRoutes;
